import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/MotoristsMobilePhoneDrivingHero-bg.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .mmpd { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .mmpd-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .mmpd-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .mmpd-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .mmpd-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .mmpd-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .mmpd-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .mmpd-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .mmpd-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .mmpd-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .mmpd-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .mmpd-bc-item:hover { color: #EB2019; }
  .mmpd-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .mmpd-bc-sep img { width: 24px; height: 24px; display: block; }
  .mmpd-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .mmpd-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .mmpd-main-section { padding: 80px 0 120px 0; }
  .mmpd-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .mmpd-article { flex: 1; min-width: 0; }

  .mmpd-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .mmpd-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .mmpd-meta-item:last-child { border-right: none; padding-right: 0; }
  .mmpd-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .mmpd-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .mmpd-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .mmpd-article-body p { margin-bottom: 20px; }
  .mmpd-article-body p:last-child { margin-bottom: 0; }

  /* Red left-border blockquote */
  .mmpd-blockquote {
    border-left: 6px solid #EB2019;
    padding-left: 16px;
    margin-bottom: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }

  /* Bold closing quote */
  .mmpd-bold-quote {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; display: block; margin-bottom: 20px;
  }

  .mmpd-article-body strong { font-weight: 600; color: #202020; }

  /* ══ BOTTOM ROW ══ */
  .mmpd-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .mmpd-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .mmpd-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .mmpd-nav-btn:hover { color: #EB2019; }
  .mmpd-nav-btn img { width: 40px; height: 40px; display: block; }

  .mmpd-share-icons { display: flex; align-items: center; gap: 20px; }
  .mmpd-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .mmpd-share-icon:hover { opacity: 0.85; }
  .mmpd-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .mmpd-sidebar { flex: 0 0 475px; }
  .mmpd-sidebar-block { margin-bottom: 60px; }
  .mmpd-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .mmpd-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .mmpd-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .mmpd-recent-item:hover .mmpd-recent-title { color: #EB2019; }
  .mmpd-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .mmpd-recent-body { flex: 1; min-width: 0; }
  .mmpd-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .mmpd-social-icons { display: flex; align-items: center; gap: 30px; }
  .mmpd-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .mmpd-social-icon:hover { opacity: 0.8; }
  .mmpd-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .mmpd-hero             { height: 350px; }
    .mmpd-hero-content     { padding: 0 32px; }
    .mmpd-hero-title       { font-size: 30px; }
    .mmpd-hero-divider     { width: 100%; max-width: 575px; }
    .mmpd-breadcrumb       { padding: 24px 0 0 0; }
    .mmpd-breadcrumb-inner { padding: 0 32px; }
    .mmpd-inner            { padding: 0 32px; }
    .mmpd-main-section     { padding: 48px 0 60px 0; }
    .mmpd-main-row         { flex-direction: column; gap: 48px; }
    .mmpd-sidebar          { flex: none; width: 100%; }
    .mmpd-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .mmpd-hero             { height: 360px; }
    .mmpd-hero-content     { padding: 0 16px; }
    .mmpd-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .mmpd-hero-divider     { width: 100%; }
    .mmpd-hero-subtitle    { font-size: 14px; }
    .mmpd-breadcrumb       { padding: 30px 0 0 0; }
    .mmpd-breadcrumb-inner { padding: 0 16px; }
    .mmpd-bc-item          { font-size: 14px; gap: 14px; }
    .mmpd-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .mmpd-bc-sep img       { width: 22px; height: 22px; }
    .mmpd-inner            { padding: 0 16px; }
    .mmpd-main-section     { padding: 30px 0 60px 0; }
    .mmpd-main-row         { flex-direction: column; gap: 60px; }
    .mmpd-sidebar          { flex: none; width: 100%; }
    .mmpd-article-title    { font-size: 20px; margin-bottom: 15px; }
    .mmpd-article-body     { font-size: 14px; }
    .mmpd-article-body p   { margin-bottom: 15px; }
    .mmpd-blockquote       { font-size: 14px; margin-bottom: 15px; }
    .mmpd-bold-quote       { font-size: 14px; margin-bottom: 15px; }
    .mmpd-article-body strong { font-size: 16px; }
    .mmpd-meta-item        { font-size: 14px; }
    .mmpd-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .mmpd-nav-btn img      { width: 24px; height: 24px; }
    .mmpd-nav-btn          { font-size: 14px; }
    .mmpd-share-icon img   { width: 34px; height: 34px; }
    .mmpd-sidebar-title    { font-size: 20px; }
    .mmpd-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
 {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function MotoristsMobilePhoneDriving() {
  return (
    <div className="mmpd">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="mmpd-hero">
        <img className="mmpd-hero-bg" src={HeroBgImg} alt="Motorists mobile phone use is today's drink-driving Hero" />
        <div className="mmpd-hero-overlay" />
        <div className="mmpd-hero-content">
          <h1 className="mmpd-hero-title">
            Motorists' mobile phone use is today's 'drink-driving', authorities say
          </h1>
          <hr className="mmpd-hero-divider" />
          <p className="mmpd-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="mmpd-breadcrumb" aria-label="Breadcrumb">
        <div className="mmpd-breadcrumb-inner">
          <a href="/" className="mmpd-bc-item">Home</a>
          <span className="mmpd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="mmpd-bc-item">News &amp; Updates</a>
          <span className="mmpd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="mmpd-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="mmpd-main-section">
        <div className="mmpd-inner">
          <div className="mmpd-main-row">

            {/* ── ARTICLE ── */}
            <article className="mmpd-article">

              {/* Meta bar */}
              <div className="mmpd-meta-bar">
                <span className="mmpd-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="mmpd-meta-item"><img src={CalendarIcon} alt="date" /> March 26, 2024</span>
                <span className="mmpd-meta-item"><img src={ClockIconImg} alt="time" /> 11:02 am</span>
                <span className="mmpd-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="mmpd-article-title">
                Motorists' mobile phone use is today's 'drink-driving', authorities say
              </h1>

              {/* Body */}
              <div className="mmpd-article-body">

                <blockquote className="mmpd-blockquote">
                  "If you're travelling at 100km/h an hour, for 55 metres it's equivalent to having a blindfold on."
                </blockquote>

                <p>Experts are meeting on Friday to solve Victoria's soaring road death toll, which has reached 137 this year, compared with 88 at the same time in 2018.</p>

                <p>Speaking ahead of the summit, the state's roads safety minister, Jaala Pulford, said a new media campaign will highlight the danger of drivers using mobile phones."</p>

                <p>Mobile phone use in cars is the drink-driving of this generation," she said. "The research tells us people think just two seconds is not as horrifically hazardous as it is.</p>

                <span className="mmpd-bold-quote"><strong>"If you're travelling at 100km/h an hour, for 55 metres it's equivalent to having a blindfold on."</strong></span>

              </div>

              {/* ── Bottom row ── */}
              <div className="mmpd-bottom-row">
                <div className="mmpd-bottom-nav">
                  <a href="/news/acusensus-texting-driving" className="mmpd-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/acusensus-traffic-technology" className="mmpd-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="mmpd-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/motorists-mobile-phone-use-is-todays-drink-driving-authorities-say/" className="mmpd-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%25E2%2580%259CIf%2520you%25E2%2580%2599re%2520travelling%2520at%2520100km%2Fh%2520an%2520hour%2C%2520for%252055%2520metres%2520it%25E2%2580%2599s%2520equivalent%2520to%2520having%2520a%2520blindfold%2520on.%25E2%2580%259D%2520https%3A%2F%2Fadorpowertron.com%2Fmotorists-mobile-phone-use-is-todays-drink-driving-authorities-say%2F&mode=login" className="mmpd-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fmotorists-mobile-phone-use-is-todays-drink-driving-authorities-say%2F%26title%3DAuthorities%2520compare%2520phone%2520use%2520while%2520driving%2520to%2520DUI%2520%257C%2520Ador%26summary%3D%25E2%2580%259CIf%2520you%25E2%2580%2599re%2520travelling%2520at%2520100km%2Fh%2520an%2520hour%2C%2520for%252055%2520metres%2520it%25E2%2580%2599s%2520equivalent%2520to%2520having%2520a%2520blindfold%2520on.%25E2%2580%259D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fmotorists-mobile-phone-use-is-todays-drink-driving-authorities-say%2F" className="mmpd-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="mmpd-sidebar">

              {/* Recent Posts */}
              <div className="mmpd-sidebar-block">
                <p className="mmpd-sidebar-title">Recent Posts</p>
                <div className="mmpd-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="mmpd-recent-item">
                      <img src={post.img} alt={post.title} className="mmpd-recent-img" />
                      <div className="mmpd-recent-body">
                        <span className="mmpd-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="mmpd-sidebar-block">
                <p className="mmpd-sidebar-title">Social Media</p>
                <div className="mmpd-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="mmpd-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="mmpd-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}